import { FC } from 'react';
import DelayedModalLsContent from './DelayedModalLsContent';
import { NudosGenericModal, NudosModalContent } from '../../../../../components/NudosComponents';
import { IlogisticServiceDetails, IlogisticServiceTrelloCardData } from '../../../../../types/services';

export interface IDelayedModalLS {
  closeAndRestoreList: () => void;
  logisticServiceDetails?: IlogisticServiceDetails;
  closeModalAfterSubmitCallback: () => void;
  handleSuccessInUpdatingStatus: () => void;
  selectedLogisticServiceDataForModal: IlogisticServiceTrelloCardData;
  refreshLogisticServiceDetails: () => void;
  suppressOpenReportPanelInModal?: boolean;
}

const DelayedModalLS: FC<IDelayedModalLS> = ({
  closeAndRestoreList,
  logisticServiceDetails,
  closeModalAfterSubmitCallback,
  handleSuccessInUpdatingStatus,
  selectedLogisticServiceDataForModal,
  refreshLogisticServiceDetails,
  suppressOpenReportPanelInModal = false
}: IDelayedModalLS) => {
  return (
    <div>
      <NudosGenericModal
        closeModalCallback={closeAndRestoreList}
        modalContent={
          <NudosModalContent
            noScroll
            customWidth="780px"
            customHeight="580px"
            toCloseModal={closeAndRestoreList}
            modalContentTitle="Actualizar fechas"
            CustomModalComponent={
              <DelayedModalLsContent
                handleSuccessInUpdatingStatus={handleSuccessInUpdatingStatus}
                logisticServiceDetails={logisticServiceDetails}
                closeModalAfterSubmitCallback={closeModalAfterSubmitCallback}
                selectedLogisticServiceDataForModal={selectedLogisticServiceDataForModal}
                refreshLogisticServiceDetails={refreshLogisticServiceDetails}
                suppressOpenReportPanelInModal={suppressOpenReportPanelInModal}
              />
            }
          />
        }
      />
    </div>
  );
};

export default DelayedModalLS;
